import styled from 'styled-components';

export const BoardContainer = styled.div`
  height: 100vh;
`;

export const MainLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;
